module.exports = __webpack_public_path__ + "img/logo.95670992.png";